import React from "react";
import SectionItem from "./SectionItem";


function SectionList({ sections = [], answers, onAnswerChange, validationErrors }) {
  if (!sections || sections.length === 0) {
    return null;
  }

  return (
    <div className="ids-mb-4">

      {sections.map((section) => (
        <SectionItem
          key={section.sectionId}
          section={section}
          answers={answers}
          onAnswerChange={onAnswerChange}
          validationErrors={validationErrors}
        />
      ))}
    </div>
  );
}

export default SectionList;
